// extracted by mini-css-extract-plugin
export var chip = "_mh-2";
export var chipBody = "_mh-8";
export var chipHeader = "_mh-9";
export var chipWithKind = "_mh-7";
export var icon = "_mh-3";
export var kind = "_mh-a";
export var remove = "_mh-5";
export var removeIcon = "_mh-6";
export var row = "_mh-0";
export var rowHistorical = "_mh-1";
export var text = "_mh-4";